import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import MeaButton from "../../../components/MeaButton";
import { InputText } from "primereact/inputtext";
import familyAPI from "../../../services/family";
import { Message } from "primereact/message";


const RequestAccess = ({ embedded = false }) => {

  const captchaRef = useRef(null);
  const [token, setToken] = useState(null);

  const [email, setEmail] = useState("");

  const [loading, setLoading] = useState(false);

  const [errMsg, setErrMsg] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const _token = captchaRef.current.getValue();
    familyAPI.RequestAccess(email, _token).then((data) => {
      console.log(data);
    }).finally(() => {
      setErrMsg("Si le mail renseigné est connu de l'école, vous recevrez un lien d'accès personnel sur votre boite mail. Merci de vérifier vos spams.");
      setLoading(false);
    })
  };

  if (embedded) {
    return (
      <div className="surface-card p-2  w-full">
        <div className="text-center">

          <div className="text-900 text-3xl font-medium mb-3">Espace famille</div>
          <span className="text-600 font-medium line-height-3">Veuillez saisir votre email connu de l'école pour recevoir un lien d'accès personnel sur votre boite mail. Merci de vérifier vos spams.</span>
        </div>

        <div>
          <form onSubmit={handleSubmit}>
            <div className="flex align-items-center justify-content-between mb-6">
              <div className="flex align-items-center">
              </div>
            </div>
            <label htmlFor="email" className="block text-900 font-medium mb-2">Adresse email</label>
            <InputText id="email" type="text" placeholder="" className="w-full mb-3" value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus />
            <div className="flex align-items-center justify-content-between mb-4 request-access-recaptcha-wrap">
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                onChange={(value) => {
                  setToken(value);
                }}
                ref={captchaRef}
              ></ReCAPTCHA>
            </div>
            {errMsg && (
              <div className="mb-4">
                <Message severity="success" text="Votre demande a bien été prise en compte." />
                <Message severity="info" text={errMsg} />
              </div>
            )}
            <MeaButton loading={loading} disabled={token === null || email === "" || errMsg !== ""} style={{ height: "50px" }} label="Envoyer le lien d'accès personnel" icon="pi pi-user" className="w-full" />
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={{ paddingTop: "30px" }} className="flex justify-content-center flex-wrap">
      <div style={{ maxWidth: "400px" }} className="surface-card p-4 shadow-2 border-round w-full lg:w-6">
        <div className="text-center">

          <div className="text-900 text-3xl font-medium mb-3">Espace famille</div>
          <span className="text-600 font-medium line-height-3">Veuillez saisir votre email connu de l'école pour recevoir un lien d'accès personnel sur votre boite mail. Merci de vérifier vos spams.</span>
        </div>

        <div>
          <form onSubmit={handleSubmit}>

            <div className="flex align-items-center justify-content-between mb-6">
              <div className="flex align-items-center">
              </div>
            </div>
            <label htmlFor="email" className="block text-900 font-medium mb-2">Adresse email</label>
            <InputText id="email" type="text" placeholder="" className="w-full mb-3" value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus />
            <div className="flex align-items-center justify-content-between mb-4 request-access-recaptcha-wrap">
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                onChange={(value) => {
                  setToken(value);
                }}
                ref={captchaRef}
              ></ReCAPTCHA>
            </div>
            {errMsg && (
              <div className="mb-4">
                <Message severity="success" text="Votre demande a bien été prise en compte." />
                <Message severity="info" text={errMsg} />
              </div>
            )}
            <MeaButton loading={loading} disabled={token === null || email === "" || errMsg !== ""} style={{ height: "50px" }} label="Envoyer le lien d'accès personnel" icon="pi pi-user" className="w-full" />

          </form>
        </div>

      </div>

    </div>
  );
};

export default RequestAccess;